// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiWordpress as RawSiWordpress } from "react-icons/si";
export const SiWordpress = /* @__PURE__ */ createIcon(RawSiWordpress, "SiWordpress", 0);
